import * as Sentry from '@sentry/browser'

let initialized = false

interface SentryEnv {
  VITE_SENTRY_DSN?: string
  VITE_APP_ENV?: string
  VITE_APP_VERSION?: string
  MODE: string
}

export function initSentry(): void {
  if (initialized) {
    return
  }

  const env = import.meta.env as unknown as SentryEnv
  const dsn = env.VITE_SENTRY_DSN
  if (!dsn) {
    return
  }

  const environment = env.VITE_APP_ENV ?? env.MODE
  const release = env.VITE_APP_VERSION

  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate: environment === 'production' ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: environment === 'production' ? 1.0 : 0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    sendDefaultPii: false,
  })

  initialized = true
}
